import { render, staticRenderFns } from "./World.vue?vue&type=template&id=3284e209&"
import script from "./World.vue?vue&type=script&lang=js&"
export * from "./World.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "World.vue"
export default component.exports